class CopySignatureToClibpoard {
  constructor() {
    if (this._jsClipboardSupported()) {
      this.clipboardSetup()
      this.textWithButtonForClipboardCopy()
    } else {
      this.alertNoJSClipboard()
    }
  }


  textWithButtonForClipboardCopy() {
    $(".js-text-for-clipboard-copy:not(.event_binded)").one("click", function(e) {
      var clipData = $(this).data("text-for-clipboard")
      clipboard
        .copy({
          "text/plain": clipData
        })
        .then(
          function() {
            alert(CopySignatureToClibpoard.copyTextSuccessMessage)
          },
          function(err) {
            console.log("failure of copy", err)
          }
        )
      e.preventDefault()
    })
    $(".js-text-for-clipboard-copy").addClass("event_binded")
  }

  clipboardSetup() {
    var copySuccessMessage = this._i18n_translation("copy-signature-alert-message")
    var copy_support_alert = this._i18n_translation("copy-support-message")
    var copy_support_additional = this._i18n_translation("copy-support-additional")


    CopySignatureToClibpoard.copyTextSuccessMessage = this._i18n_translation("text-for-clipboard-copy-alert-message")
    copy_support_alert =
      copy_support_alert + "\n" + copy_support_additional + navigator.userAgent

    $(".js-clipboard-copy-button").click(function(e) {
      var signatureDOMSelector = $(this).data("copy-selector-target")
      var plainTextClipboardGetsHtmlCode = $(this).data("plain-text-gets-html")
      var htmlForClipboard = $(signatureDOMSelector).html()

      console.log("signatureDOMSelector :", signatureDOMSelector)
      console.log("Plain text clipboard will get html code :", plainTextClipboardGetsHtmlCode)
      console.log("Html Code: ", htmlForClipboard)

      var textForClipboard = plainTextClipboardGetsHtmlCode
        ? htmlForClipboard
        : copySuccessMessage

      clipboard
        .copy({
          "text/plain": textForClipboard,
          "text/html": htmlForClipboard
        })
        .then(
          function() {
            alert(copySuccessMessage)
          },
          function(err) {
            console.log("failure of copy", err)
          }
        )
      e.preventDefault()
    })

    $(".js-clipboard-copy-button").show()
    $(".js-clipboard-copy-button").removeClass("d-none")
  }


  alertNoJSClipboard() {
    // Old browsers that do not support clipboard management
    // And did rely on flash in the past
    alert(this._i18n_translation("copy-outdated-browser-alert-message"))
  }

  _i18n_translation(key) {
    var translation = $(`.js-translations .${key}`)
      .text()
      .trim()
    return translation
  }

  _jsClipboardSupported() {
    this._browserspec()
    // console.log("navigator.browserSpecs.name", navigator.browserSpecs.name, navigator.browserSpecs.version)
    switch (navigator.browserSpecs.name) {
      case "Chrome":
        return navigator.browserSpecs.version >= 42
      case "Firefox":
        return navigator.browserSpecs.version >= 57
      case "Safari":
        return navigator.browserSpecs.version >= 10
      case "Edge":
        return navigator.browserSpecs.version >= 17
      case "Opera":
        return navigator.browserSpecs.version >= 50
      default:
        false
    }

    return false
  }

   _browserspec() {
    navigator.browserSpecs = (function() {
      var ua = navigator.userAgent,
        tem,
        M =
          ua.match(
            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
          ) || []
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || []
        return {
          name: "IE",
          version: tem[1] || ""
        }
      }
      if (M[1] === "Chrome") {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
        if (tem != null)
          return {
            name: tem[1].replace("OPR", "Opera"),
            version: tem[2]
          }
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"]
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1])
      return {
        name: M[0],
        version: M[1]
      }
    })()
  }

}

export { CopySignatureToClibpoard }
